module.exports = __webpack_public_path__ + "expected-in-n-f-days.png?b27414e8d3d65524a288753807a81113";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/expected-in-n-f-days.png
// module id = 483
// module chunks = 0